import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
export const FeatureGridSection = () => {
  const videoRef = useRef(null);
  const instagramUrl = 'https://www.instagram.com/veranova_klussen?igsh=MTY5MmppcGx2ZmN2OQ==';
  useEffect(() => {
    // Only attempt to play the video when it's muted to avoid autoplay policy issues
    if (videoRef.current) {
      videoRef.current.muted = true; // Ensure video is muted
      videoRef.current.play().catch(error => {
        console.log('Video autoplay prevented:', error);
      });
    }
  }, []);
  const features = [{
    title: 'Projecten',
    subtitle: 'Bekijk onze recente projecten en laat u inspireren',
    buttonText: 'Bekijk projecten',
    buttonLink: instagramUrl,
    type: 'video',
    videoSrc: 'https://egveranda.nl/wp-content/uploads/2024/12/Showroom-v1-15sec_loop.mp4',
    isExternal: true
  }, {
    title: 'Installatie in uitvoering',
    subtitle: 'Volg het proces van ontwerp tot realisatie',
    buttonText: 'Bekijk werkwijze',
    buttonLink: '/over-ons',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6csxjgvfwC84VMs7DY8i12/IMG-20250423-WA0009.jpg',
    isLink: true
  }, {
    title: 'Vakmanschap',
    subtitle: 'Precisie en kwaliteit in elk detail',
    buttonText: 'Ontdek meer',
    buttonLink: '/producten',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bbqzAX3HGa1qV4DnaGXJAq/IMG-20250423-WA0011.jpg',
    isLink: true
  }, {
    title: 'Maatwerk overkappingen',
    subtitle: 'Perfect passend bij uw woning',
    buttonText: 'Bekijk mogelijkheden',
    buttonLink: '/producten',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7nk9VQSmML7hwtXboprLaz/IMG-20250423-WA0012.jpg',
    isLight: true,
    isLink: true
  }];
  return <section className="py-20 bg-white" data-id="element-449">
      <div className="container mx-auto px-6" data-id="element-450">
        {/* Intro Text */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16 items-center" data-id="element-451">
          <div data-id="element-452">
            <div className="inline-flex items-center gap-3 mb-4" data-id="element-453">
              <div className="w-8 h-[2px] bg-[#CDA735]" data-id="element-454"></div>
              <span className="text-sm font-medium text-[#B89429] uppercase tracking-wider" data-id="element-455">
                100% Nederlands vakmanschap
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-light text-gray-800 mb-2" data-id="element-456">
              Alles voor uw veranda
            </h2>
          </div>
          <div className="space-y-4" data-id="element-457">
            <p className="text-gray-700 text-lg leading-relaxed" data-id="element-458">
              Verbind binnen en buiten met elkaar met een veranda en maak het
              compleet met een glazen schuifwand, zonwering en een lamellendak.
              Ook voor aluminium kozijnen en binnendeuren zijn wij het adres.
            </p>
            <p className="text-gray-700 text-lg leading-relaxed" data-id="element-459">
              <span className="font-medium text-[#B89429]" data-id="element-460">
                100% Nederlandse productie
              </span>{' '}
              in onze eigen fabriek betekent voor u: superieure kwaliteit,
              snelle levertijden en vakkundige installatie door ons eigen team
              van experts.
            </p>
          </div>
        </div>
        {/* Feature Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-461">
          {features.map((feature, index) => <div key={index} className="relative rounded-lg overflow-hidden shadow-lg h-[400px] group" data-id="element-462">
              {feature.type === 'video' ? <video ref={videoRef} className="w-full h-full object-cover" muted={true} playsInline loop aria-label={`Video: ${feature.title} - ${feature.subtitle}`} data-id="element-463">
                  <source src={feature.videoSrc} type="video/mp4" data-id="element-464" />
                  Your browser does not support the video tag.
                </video> : <img src={feature.image} alt={`Veranova ${feature.title} - ${feature.subtitle}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-465" />}
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/60 to-transparent opacity-80" data-id="element-466"></div>
              {/* Circular Overlay with Content */}
              <div className="absolute top-8 left-8 bg-gray-800/80 backdrop-blur-sm rounded-full p-6 w-48 h-48 flex flex-col justify-center items-center text-center" data-id="element-467">
                <p className="text-white font-semibold text-xl mb-1" data-id="element-468">
                  {feature.title}
                </p>
                <p className="text-white/80 text-sm" data-id="element-469">{feature.subtitle}</p>
              </div>
              {/* Title and Button at Bottom */}
              <div className="absolute bottom-0 left-0 w-full p-8 flex flex-col" data-id="element-470">
                <p className="text-white text-2xl font-bold mb-4" data-id="element-471">
                  {feature.title}
                </p>
                {feature.isExternal ? <a href={feature.buttonLink} target="_blank" rel="noopener noreferrer" className={`inline-block w-fit px-6 py-2 rounded-full text-sm font-medium transition-colors ${feature.isLight ? 'bg-white text-[#CDA735] hover:bg-gray-100' : 'bg-[#CDA735] text-white hover:bg-[#B89429] hover:shadow-[0_0_20px_rgba(205,167,53,0.3)]'}`} data-id="element-472">
                    {feature.buttonText}
                  </a> : feature.isLink ? <Link to={feature.buttonLink} className={`inline-block w-fit px-6 py-2 rounded-full text-sm font-medium transition-colors ${feature.isLight ? 'bg-white text-[#CDA735] hover:bg-gray-100' : 'bg-[#CDA735] text-white hover:bg-[#B89429] hover:shadow-[0_0_20px_rgba(205,167,53,0.3)]'}`} data-id="element-473">
                    {feature.buttonText}
                  </Link> : <a href={feature.buttonLink} className={`inline-block w-fit px-6 py-2 rounded-full text-sm font-medium transition-colors ${feature.isLight ? 'bg-white text-[#CDA735] hover:bg-gray-100' : 'bg-[#CDA735] text-white hover:bg-[#B89429] hover:shadow-[0_0_20px_rgba(205,167,53,0.3)]'}`} data-id="element-474">
                    {feature.buttonText}
                  </a>}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};